import { TopicType, topics } from '@api';
import { apiFetch, wretchRequest } from '@terminal/utils/api-fetch/apiFetch';

export const getTopics = (type: TopicType, signal?: AbortSignal) =>
  wretchRequest(topics.getTopics.path(type), {
    schema: topics.getTopics.schema,
    signal,
  });

export const fetchTopics = (type: TopicType, signal?: AbortSignal) =>
  apiFetch(topics.getTopics.path(type), {
    schema: topics.getTopics.schema,
    signal,
  });

export const getTopic = (type: TopicType, code: string, signal?: AbortSignal) =>
  wretchRequest(topics.getTopic.path(type, code), {
    schema: topics.getTopic.schema,
    signal,
  });

export const postTopic = (type: TopicType, code: string) =>
  wretchRequest(topics.postTopic.path(type, code), {
    method: 'post',
    schema: topics.postTopic.schema,
  });

export const deleteTopic = (type: TopicType, code: string) =>
  wretchRequest(topics.deleteTopic.path(type, code), {
    method: 'delete',
    schema: topics.deleteTopic.schema,
  });
